import {Accordion} from '../../../../ffn-site/Resources/Private/TypeScript/Components/AccordionClass'
import {Popover} from "../../../../ffn-site/Resources/Private/TypeScript/Components/PopoverClass";

export class Search {
    lists: NodeListOf<HTMLElement>;

    constructor() {
        this.lists = document.querySelectorAll('[data-apprenticeship-list]');
        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        this.lists.forEach((list) => {
            const key = list.dataset.apprenticeshipList;
            const form = document.querySelector('[data-apprenticeship-search-form="' + key + '"]');
            form.addEventListener('turbo:submit-start', () => {
                list.querySelector('[data-apprenticeship-list-loading]').classList.remove('d-none');
            });
            list.addEventListener('turbo:frame-load', () => {
                const accordions: NodeListOf<HTMLElement> = list.querySelectorAll('[data-accordion]');
                accordions.forEach((el) => {
                    new Accordion(el);
                });
                const popovers: NodeListOf<HTMLElement> = list.querySelectorAll('[data-popover]');
                popovers.forEach((el) => {
                    new Popover(el);
                });
                window.scrollTo({
                    top: list.offsetTop - 80,
                    behavior: "smooth"
                });
            });
        });
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new Search();
});
